import Image from "next/image"
import Link from "next/link"
import Head from "next/head"

export default function FotografiaAutoral() {
  const Squares = (title, picUrl, link) => {
    return (
      <Link href={link}>
        <a className="text-white relative text-almost-white hover:text-white">
          <Image
            src={picUrl}
            alt={title}
            width={840}
            height={750}
            objectFit="cover"
            quality={100}
            priority
            className="transition ease-in duration-500 scale-110 hover:scale-100"
          />
          <div className="absolute bottom-0 left-0 right-0 p-5 bg-gradient-to-t from-midnight">
            <h3 className="font-lato">{title}</h3>
          </div>
        </a>
      </Link>
    )
  }

  return (
    <>
      <Head>
        <title>Sara Fontoura - Fotografia Autoral</title>
        <meta
          property="og:title"
          content="Sara Fontoura - Fotografia Autoral"
          key="title"
        />
        <meta
          property="og:description"
          content="Fotografia Autoral - Todos os trabalhos"
          key="ogdesc"
        />
      </Head>
      <div className="h-[400px] md:h-[50vh] flex flex-col justify-center p-5">
        <div className="container mx-auto">
          <h1 className="font-josefin-sans text-6xl md:text-8xl text-left text-white">
            Fotografia <br /> Autoral
          </h1>
        </div>
      </div>
      <div className="container mx-auto text-white px-4 lg:px-0 font-lato mb-28 lg:mb-[200px]">
        <p className="mb-2">
          Através da fotografia autoral consigo ser eu mesma e expressar o que
          estou a sentir.
        </p>
        <p className="mb-2">
          Descobri esta paixão em meio a pandemia, onde a única pessoa que podia
          fotografar era eu mesma.
        </p>
        <p className="mb-2">
          Enfrentei o medo de estar à frente da lente e entreguei-me a
          fotografia como nunca antes o tinha feito.
        </p>
        <p className="mb-2">As imagens abaixo falam por si.</p>
      </div>
      <div className="container mx-auto grid grid-cols-2 gap-4 mb-20">
        {Squares(
          "Florescer",
          "/fotos/autoral/florescer/DSC09020.webp",
          "/portfolio/fotografia-autoral/florescer"
        )}
        {Squares(
          "Isolamento",
          "/fotos/autoral/isolamento/1.webp",
          "/portfolio/fotografia-autoral/isolamento"
        )}
        {Squares(
          "Media",
          "/fotos/autoral/media/1.webp",
          "/portfolio/fotografia-autoral/media"
        )}
        {Squares(
          "Permanência",
          "/fotos/autoral/permanencia/DSC01101.webp",
          "/portfolio/fotografia-autoral/permanencia"
        )}
      </div>
    </>
  )
}